import { DollarSign, RotateCw, ShoppingCart, TrendingUp } from 'lucide-react'
import { StatCard } from '@shared/design-system/ui'
import type { RecuperaMetrics } from '../api/recupera-ai.contract'
import { cardsGrid } from './recupera-ai.css'

function recoveryRate(recovered: number, abandoned: number): string {
  if (abandoned <= 0) return '0.0'
  return ((recovered / abandoned) * 100).toFixed(1)
}

function formatCurrency(raw: string): string {
  const parsed = Number.parseFloat(raw)
  if (Number.isNaN(parsed)) return `R$ ${raw}`
  return parsed.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function RecuperaMetricsCards({ metrics }: { metrics: RecuperaMetrics }) {
  const total = metrics.total
  return (
    <div className={cardsGrid} data-testid="recupera-ai-cards">
      <StatCard
        label="Carrinhos abandonados"
        value={String(total.abandoned_count)}
        icon={<ShoppingCart size={18} />}
      />
      <StatCard
        label="Recuperados"
        value={String(total.recovered_count)}
        icon={<RotateCw size={18} />}
      />
      <StatCard
        label="Taxa de recuperação"
        value={`${recoveryRate(total.recovered_count, total.abandoned_count)}%`}
        icon={<TrendingUp size={18} />}
      />
      <StatCard
        label="Valor recuperado"
        value={formatCurrency(total.recovered_revenue)}
        icon={<DollarSign size={18} />}
      />
    </div>
  )
}
